<script>
  import {link} from 'svelte-spa-router'
  import { bg_verde_consulta } from '../../constantes';
  import { currentURL } from '../../store.js';

  let currentPageURL = "";

  currentURL.subscribe(value => {
    currentPageURL=value;
  });
  
</script>


<nav class="navbar navbar-expand-lg" data-bs-theme="dark">
  <div class="container-fluid">
    <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
      <span class="navbar-toggler-icon"></span>
    </button>
    <div class="collapse navbar-collapse" id="navbarSupportedContent">
      <ul class="navbar-nav me-auto mb-2 mb-lg-0">
        <li class="nav-item {currentPageURL=='/'?'active':''}">
          <a class="nav-link" aria-current="page" href="/"  on:click={()=>{currentURL.update(value =>"/")}} use:link>Inicio</a>
        </li>
        <li class="nav-item {currentPageURL=='/quienes-somos'?'active':''}">
            <a class="nav-link" aria-current="page" href="/quienes-somos" on:click={()=>{currentURL.update(value =>"/quienes-somos")}} use:link>Quiénes Somos</a>
        </li>
        <li class="nav-item {currentPageURL=='/contactenos'?'active':''}">
          <a class="nav-link" aria-current="page" href="/contactenos" on:click={()=>{currentURL.update(value =>"/contactenos")}} use:link>Contáctenos</a>
      </li>
      </ul>
    </div>
  </div>
</nav>

<style>
  li.active{
    border-bottom: 4px solid #87AF20;
  }
  li.active a, li:hover a{
    color: #87AF20;
    text-decoration: none;
  }
  li a, li a:hover{
    color: #01479e;
    text-decoration: none;
  }
  li:hover{
    border-bottom: 4px solid #01479e;
  }

  footer li.active a, footer li:hover a{
    color: #FFF;
  }

  footer li a{
    color: #FFF;
  }
  footer li a:hover{
    color: #87AF20;
  }
  
</style>
